<template>
  <ModalDefault modal_id="showCategoriesModal"
                header="y"
                size="modal-lg modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_722')"
                :method="updateCategory"
                :footer="categories.category.title"
                icon="bx bx-badge-check mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <div>
        <div class=" d-flex">
          <div class="file-upload-center cursor-default w-100"  style="align-items: center; align-self: center;">
            <div class="d-block pt-2 px-2">
              <div class="col-12 px-0">
                <div class="input-group mb-4">
                  <input 
                    type="text" 
                    v-model="categories.category.title" 
                    class="input-field"
                    placeholder="Título da categoria">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
            <h5>Subcategorias</h5>
            <table class="table">
                <tr v-for="(subcategory, index) in categories.category.subcategories">
                    <td width="70%">
                        <input type="hidden"
                            :value="subcategory.id"
                        />
                        <input type="text"
                            disabled
                            :placeholder="subcategory.title"
                            :default-value="subcategory.title"
                            :value="subcategory.title"
                        />
                    </td> 
                    <td width="30%">
                        <div class="row">
                            <div class="col-6"></div>
                            <div class="col-6">

                                <div 
                                @click.stop="alertDeleteSubCategory(subcategory)"
                                class="cursor_pointer badge btn-outline-secondary_edit text-danger d-flex py-2 shadow-sm px-2">
                                <i class="bx bx-trash px-1"></i>
                                <span class="ml-1 pr-1">{{ getTranslations('expression_200') }}</span>
                            </div>
                        </div>
                      </div>
                    </td>
                </tr>
            </table>
        </div>
      </div>
      <div class="row text-center" id="subcategoryForm">
        <div class="col-10">
            <input type="text" id="subcategoryTitle" class="input-field" />
        </div>
        <div class="col-2">
            <button
            @click="(e) => {
                addSubCategory() 
                e.preventDefault(); 
            }"
            id="subcategoryConfirm"
            class="btn btn-success"><i class='bx bx-check'></i></button>
            <button
            @click="(e) => {
                cancelAddSubcategory();
                e.preventDefault(); 
            }"
            id="subcategoryCancel"
            class="btn btn-danger"><i class='bx bx-x' ></i></button>
        </div>
      </div>
      <div class="row" id="openAddSubcategoryButton">
        <div class="col-12 text-center">
            <button 
                class="btn btn-primary"
                
                @click="(e) => {
                    openAddSubcategory();
                    e.preventDefault();
                }"    
            >Adicionar subcategoria</button>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
      <div>
          <span @click.prevent="updateCategory" data-dismiss="modal" class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3">
            <span class="">{{ getTranslations('expression_120') }}</span>
          </span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import {mapGetters, mapState} from "vuex";
import $ from "jquery";

export default {
  name: "ModalEditCategory",
  components: {
    ModalDefault,
  },
  computed: {
    ...mapState(['channels', 'departments', 'categories']),
    ...mapGetters(['getDepartmentsArray']),
  },
  mounted(){
    $("#subcategoryForm").hide();
  },
  methods: {
    openAddSubcategory(){
        $("#subcategoryTitle").val("");
        $("#subcategoryForm").show();
        $("#openAddSubcategoryButton").hide();
    },
    cancelAddSubcategory(){
        $("#subcategoryTitle").val("");
        $("#subcategoryForm").hide();
        $("#openAddSubcategoryButton").show();
    },
    addSubCategory(){
      let payload = {
          title: $("#subcategoryTitle").val(),
          category_id: this.categories.category.id
      }
      this.$store.dispatch('addSubCategory', payload);

      $("#subcategoryForm").hide();
      $("#openAddSubcategoryButton").show();

      //this.categories.category.subcategories.push(payload);
    },
    updateCategory(){
      if(this.categories.category.title.length < 3) return;
      this.$store.dispatch('updateCategory', this.categories.category)
      $('#showCategorysModal').modal('hide')
    },
    alertDeleteSubCategory(payload) {
      this.$swal.fire({
        title: 'Deseja excluir essa subcategoria?',
        text: this.getTranslations('expression_311'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        // cancelButtonColor: 'btn-primary',
        confirmButtonText: this.getTranslations('expression_421'),
        cancelButtonText: this.getTranslations('expression_355')
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteSubCategory(payload)
        }
      })
    },
    deleteSubCategory(payload){
        payload.department_id = this.categories.category.department_id;
        this.$store.dispatch("deleteSubCategory", payload)
        this.categories.category.subcategories.splice(
            this.categories.category.subcategories.findIndex(subcategory => subcategory.id == payload.id),
            1
        );
    },
    empty(){
      return true
    }
  }
}
</script>

<style scoped>
.input-field {
  width: 100%;
  height: 2.5rem;
  border: 1px solid rgb(156 163 175 / 0.55);

  outline: none;
  background-color: white;
  color: #858796;
  @apply px-2;
}

.input-field:focus {
  border: 1px solid #919191;
}
</style>
